import React, { useContext } from "react";
import { CheckboxTable } from "../view/CheckboxTable";
import { debug } from "../utils";
import ReportsTableRow from "./ReportsTableRow";
import ReportsTableRowSkeleton from "./ReportsTableRowSkeleton";
import { connect } from "react-redux";
import { TableContext } from "../index";
import { useReportsTableHelper } from "./useReportsTableHelper";

function ReportsTable({ reports }) {

    const { config } = useContext(TableContext);
    const helper = useReportsTableHelper();

    // Client-side filtering based on searchTerm from context
    const filteredReports = reports.filter((item) => {
        const term = (config.searchTerm || '').toLowerCase();
        if (!term) return true;

        const name = (item.name || '').toLowerCase();
        const description = (item.description || '').toLowerCase();
        const createdBy = (item.createdBy || '').toLowerCase();
        const date = item.date
            ? new Date(Number(item.date)).toLocaleString().toLowerCase()
            : '';

        return name.includes(term) || description.includes(term) || createdBy.includes(term) || date.includes(term);
    });

    //TODO implement
    const headers = [
        { name: 'REPORT NAME', sortKey: 'name', onClick: () => helper.onReportNameClick() },
        { name: 'DESCRIPTION', sortKey: 'description', onClick: () => helper.onDescriptionClick() },
        { name: 'CREATED BY', sortKey: 'createdBy', onClick: () => helper.onCreatedByClick() },
        { name: 'CREATED AT', sortKey: 'date', onClick: () => helper.onCreatedAtClick() },
        // {name: 'FORMAT'},
        { name: 'ACTIONS' }
        //{name: 'GROUP', onClick: () => {}}
    ]

    return (
        <>
            <CheckboxTable className="reports-generated-table" headers={headers} elements={filteredReports} containsEditButton={false}>
                {config.isLoading ? (
                    Array.from(new Array(10)).map((_, index) => (
                        <ReportsTableRowSkeleton key={index} index={index} />
                    ))
                ) : (
                    filteredReports.map((report, index) => <ReportsTableRow key={index} data={report} index={index} />)
                )}
            </CheckboxTable>
            {!config.isLoading && filteredReports.length === 0 && (
                <div className="oct_empty-state-v2">
                    <div className="oct_empty-state-title">No records found</div>
                    <div>Try adjusting your search or filters to find what you're looking for.</div>
                </div>
            )}
        </>
    )

}

function mapStateToProps(state) {
    debug("ReportsTable mapStateToProps", state);
    const reportsPage = state.reportsPage;
    return {
        reports: reportsPage.reports || []
    };
}


export default connect(mapStateToProps)(ReportsTable);
